import * as React from "react";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

// The one select in the app: which franchise a bid is being credited to.
//
// It renders in a portal, so it cannot inherit anything from the field. The
// paper and the option rows are styled globally in motion.scss; what is left
// here is the closed control itself.
export default function SelectLabels(props) {
  const { active, setActive, slist, disabled, placeholder = "Select a team" } =
    props;

  return (
    <FormControl fullWidth className={props.className || ""}>
      <Select
        disabled={disabled}
        displayEmpty
        value={active?.value || ""}
        onChange={(event) => setActive && setActive(event)}
        renderValue={(value) => {
          if (!value) return <span style={{ color: "#b1afaf" }}>{placeholder}</span>;
          const hit = slist?.find(
            (o) => String(o?.value) === String(value)
          );
          return hit?.option || active?.option || placeholder;
        }}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "14px",
          fontFamily: "IBMPlexSans-Medium",
          fontSize: "13px",
          color: "#363b64",

          "& .MuiSelect-select": { padding: "13px 16px" },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e3e3e3",
            borderRadius: "14px",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e3e3e3",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0040a8",
            borderWidth: "1px",
            boxShadow: "0 0 0 3px rgba(0, 64, 168, 0.1)",
          },
        }}
      >
        {slist
          ?.filter((o) => o?.option && o?.value)
          .map((o, i) => (
            <MenuItem disableRipple value={o.value} key={o.value || i}>
              {o.option}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
